import { useSnackbar } from 'notistack';

const StyledSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  const showSnackbar = (
    message: string,
    variant: 'success' | 'error' | 'info' | 'warning'
  ) => {
    let backgroundColor;
    let color;

    switch (variant) {
      case 'success':
        backgroundColor = 'var(--success-snackbar)';
        color = 'var(--success)';
        break;
      case 'error':
        backgroundColor = 'var(--error-snackbar)';
        color = 'var(--error)';
        break;
      case 'warning':
        backgroundColor = 'var(--warning-snackbar)';
        color = 'var(--warning)';
        break;
      default:
        backgroundColor = 'var(--info-snackbar)';
        color = 'var(--info)';
    }

    enqueueSnackbar(message, {
      autoHideDuration: 10000,
      variant,
      style: {
        backgroundColor,
        color,
        fontFamily: 'Outfit',
        fontWeight: 400,
        fontSize: '14px',
      },
    });
  };

  return { showSnackbar };
};

export default StyledSnackbar;
